// GlobalContext.js
import React, { createContext, useState ,useEffect} from 'react';

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [currentTab, setCurrentTab] = useState('User Profile');
    const [userProfileData, setUserProfileData] = useState({});
    const [countData, setCountData] = useState({
        agentCount: '',
        companyCount: '',
        groupCount:'',
        staffCount:''
    });
    const [selectedUser, setSelectedUser] = useState([]);//user list
 
    const [unitUserProfileData, setUnitUserProfileData] = useState({});
    const [unitCountData, setUnitCountData] = useState({
        groupCount:'',
        staffCount:''
    });

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (
        <GlobalContext.Provider value={{ 
            currentTab,
            setCurrentTab,
            userProfileData,
            setUserProfileData,
            countData,
            setCountData,
            selectedUser,
            setSelectedUser,
            unitUserProfileData,
            setUnitUserProfileData,
            unitCountData,
            setUnitCountData,
            isLoggedIn,
            setIsLoggedIn,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};